import { render, staticRenderFns } from "./erikoistujat-ja-kouluttajat.vue?vue&type=template&id=00a15e44&"
import script from "./erikoistujat-ja-kouluttajat.vue?vue&type=script&lang=ts&"
export * from "./erikoistujat-ja-kouluttajat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports